export default "__VITE_ASSET__7a3e680a__"